import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Link } from '@mui/material';
import cn from 'classnames';

import getNormalizeURL from '@utils/getNormalizeURL';

import './style.scss';

interface IProps {
  buttonTitle: string;
  linkToProductPage?: string | null;
  target?: '_blank' | '_self';
  className?: string;
}

const ViewLinkButton: FC<IProps> = ({
  buttonTitle,
  linkToProductPage,
  className,
  target = '_blank',
}) => {
  const { t } = useTranslation();

  return (
    <Link
      component="a"
      href={linkToProductPage ? getNormalizeURL(linkToProductPage) : undefined}
      underline="none"
      target={target}
      rel="noopener"
      className={cn('view-link', className)}
    >
      <OpenInNewIcon color={!linkToProductPage ? 'disabled' : 'success'} />
      <span
        className={cn('view-link__button-text', {
          'view-link__button-text--disabled': !linkToProductPage,
        })}
      >
        {buttonTitle}
      </span>
    </Link>
  );
};

export default ViewLinkButton;
